import { render, staticRenderFns } from "./ResponsibilityList.vue?vue&type=template&id=1f309261&"
import script from "./ResponsibilityList.vue?vue&type=script&lang=js&"
export * from "./ResponsibilityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports